/* =========================================================================
   GADGET MART MARKETPLACE PRO — theme.js
   ========================================================================= */
(function () {
  'use strict';

  var R = window.THEME_ROUTES || {};
  var S = window.THEME_STRINGS || {};
  var CFG = window.THEME_CONFIG || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.THEME_MONEY_FORMAT || '${{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = num(cents, 2, ' ', '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.formatMoney = formatMoney;

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(toastEl);
    }
    $('span', toastEl).textContent = msg;
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2600);
  }
  window.themeToast = toast;

  /* ---------- overlay / drawers ---------- */
  var overlay = $('#overlay');
  function openPanel(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var f = el.querySelector('input,button,a');
    if (f) setTimeout(function () { f.focus(); }, 260);
  }
  function closeAll() {
    $$('.drawer.is-open, .qv.is-open, .lightbox.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }
  window.themeOpen = openPanel;
  window.themeCloseAll = closeAll;

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openPanel(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'overlay') { closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart API ---------- */
  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetch(R.cart || '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintCart(cart);
        return cart;
      });
  }

  function paintCart(cart) {
    // counts
    $$('.js-cart-count').forEach(function (n) {
      n.textContent = cart.item_count;
      n.style.display = cart.item_count > 0 ? '' : 'none';
    });
    $$('.js-cart-total').forEach(function (n) { n.textContent = formatMoney(cart.total_price); });
    // drawer body
    var body = $('#cart-drawer-body');
    if (body) body.innerHTML = drawerItems(cart);
    var foot = $('#cart-drawer-foot');
    if (foot) foot.style.display = cart.item_count ? '' : 'none';
    paintShipBar(cart.total_price);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function drawerItems(cart) {
    if (!cart.item_count) {
      return '<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h2.2l2 12.4a1.6 1.6 0 0 0 1.6 1.3h9.3a1.6 1.6 0 0 0 1.6-1.2L21.5 7H5.2"/></svg>' +
        '<p>' + (S.cart_empty || 'Your cart is empty.') + '</p>' +
        '<a href="' + (R.all_products || '/collections/all') + '" class="btn btn--primary">' + (S.start_shopping || 'Start shopping') + '</a></div>';
    }
    return cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') : '';
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="citem__meta">' + it.variant_title + '</div>' : '';
      var was = (it.original_line_price > it.final_line_price) ? '<span class="citem__was">' + formatMoney(it.original_line_price) + '</span>' : '';
      var props = '';
      if (it.selling_plan_allocation) props = '<div class="citem__meta">' + it.selling_plan_allocation.selling_plan.name + '</div>';
      return '<div class="citem" data-key="' + it.key + '">' +
        '<img class="citem__img" src="' + img + '" alt="" loading="lazy">' +
        '<div class="citem__body">' +
        '<a class="citem__title" href="' + it.url + '">' + it.product_title + '</a>' + variant + props +
        '<div class="citem__foot">' +
        '<div class="qty" data-key="' + it.key + '"><button data-qty="-1" aria-label="Decrease">&minus;</button>' +
        '<input type="text" value="' + it.quantity + '" data-qty-input readonly><button data-qty="1" aria-label="Increase">+</button></div>' +
        '<div><span class="citem__price">' + formatMoney(it.final_line_price) + '</span>' + was + '</div>' +
        '</div>' +
        '<button class="citem__remove" data-remove="' + it.key + '">' + (S.remove || 'Remove') + '</button>' +
        '</div></div>';
    }).join('');
  }

  function paintShipBar(total) {
    var bars = $$('.js-shipbar');
    if (!bars.length) return;
    var threshold = parseFloat(CFG.freeShipAmount || 0) * 100;
    bars.forEach(function (bar) {
      var fill = $('.shipbar__fill', bar);
      var msg = $('.js-shipmsg', bar);
      if (!threshold) { bar.style.display = 'none'; return; }
      var pct = Math.min(100, (total / threshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (total >= threshold) {
        bar.classList.add('is-done');
        if (msg) msg.innerHTML = (CFG.freeShipDone || "You've unlocked free shipping");
      } else {
        bar.classList.remove('is-done');
        var remain = formatMoney(threshold - total);
        if (msg) msg.innerHTML = (CFG.freeShipMsg || "You're [amount] away from free shipping").replace('[amount]', '<b>' + remain + '</b>');
      }
    });
  }

  function addToCart(id, qty, btn, props) {
    if (btn) btn.classList.add('btn--loading');
    var payload = { items: [{ id: Number(id), quantity: qty || 1 }] };
    if (props) payload.items[0].properties = props;
    return fetch(R.cart_add || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('btn--loading');
        if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add to cart'); return null; }
        return refreshCart().then(function (cart) {
          if (CFG.cartType === 'drawer') { openPanel('cart-drawer'); }
          else { toast(S.added || 'Added to cart'); }
          return cart;
        });
      }).catch(function () {
        if (btn) btn.classList.remove('btn--loading');
        toast('Network error. Please try again.');
      });
  }
  window.themeAddToCart = addToCart;

  function changeQty(key, qty) {
    return cartFetch(R.cart_change || '/cart/change.js', { id: key, quantity: qty }).then(function (cart) {
      paintCart(cart);
      if (document.body.classList.contains('template-cart')) location.reload();
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-add-to-cart'), Number(add.getAttribute('data-qty') || 1), add);
      return;
    }
    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      var wrap = q.closest('.qty');
      var key = wrap && wrap.getAttribute('data-key');
      var input = $('input', wrap);
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty'), 10));
      if (key) { changeQty(key, next); }
      else { input.value = Math.max(1, next); input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeQty(rm.getAttribute('data-remove'), 0); return; }
  });

  /* ---------- header: sticky + height var ---------- */
  var hdr = $('.hdr');
  function setHeadVar() {
    if (!hdr) return;
    document.documentElement.style.setProperty('--head-h', hdr.offsetHeight + 'px');
  }
  setHeadVar();
  window.addEventListener('resize', setHeadVar);
  if (hdr && hdr.classList.contains('hdr--sticky')) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('is-stuck', window.scrollY > 4);
    }, { passive: true });
  }

  /* ---------- mega menu ---------- */
  (function megaMenu() {
    var btn = $('.js-mega-btn');
    var mega = $('#mega-menu');
    if (!btn || !mega) return;
    var closeTimer;
    function open() { clearTimeout(closeTimer); mega.classList.add('is-open'); btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { mega.classList.remove('is-open'); btn.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    function delayedClose() { closeTimer = setTimeout(close, 180); }

    on(btn, 'click', function (e) { e.preventDefault(); mega.classList.contains('is-open') ? close() : open(); });
    on(btn, 'mouseenter', open);
    on(btn, 'mouseleave', delayedClose);
    on(mega, 'mouseenter', function () { clearTimeout(closeTimer); });
    on(mega, 'mouseleave', delayedClose);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#mega-menu') && !e.target.closest('.js-mega-btn')) close();
    });
    // rail switching
    $$('.mega__railitem', mega).forEach(function (item) {
      function activate() {
        $$('.mega__railitem', mega).forEach(function (i) { i.classList.remove('is-active'); });
        $$('.mega__panel', mega).forEach(function (p) { p.classList.remove('is-active'); });
        item.classList.add('is-active');
        var panel = $('#' + item.getAttribute('data-panel'), mega);
        if (panel) panel.classList.add('is-active');
      }
      on(item, 'mouseenter', activate);
      on(item, 'focus', activate);
    });
  })();

  /* ---------- dropdown nav (hover panels on nav links) ---------- */
  $$('.js-navdrop').forEach(function (wrap) {
    var panel = $('.js-navdrop-panel', wrap);
    if (!panel) return;
    var t;
    on(wrap, 'mouseenter', function () { clearTimeout(t); panel.classList.add('is-open'); });
    on(wrap, 'mouseleave', function () { t = setTimeout(function () { panel.classList.remove('is-open'); }, 150); });
  });

  /* ---------- mobile nav accordions ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.js-mnav-toggle');
    if (!t) return;
    e.preventDefault();
    var item = t.closest('.mnav__item');
    var wasOpen = item.classList.contains('is-open');
    var siblings = item.parentElement.children;
    Array.prototype.forEach.call(siblings, function (s) { if (s !== item) s.classList.remove('is-open'); });
    item.classList.toggle('is-open', !wasOpen);
  });

  /* ---------- generic accordions (faq, product, footer, filters) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-acc]');
    if (!t) return;
    var item = t.closest('[data-acc-item]') || t.parentElement;
    item.classList.toggle('is-open');
    var exp = item.classList.contains('is-open');
    t.setAttribute('aria-expanded', exp ? 'true' : 'false');
  });

  /* ---------- tabs ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tab]');
    if (!t) return;
    var scope = t.closest('[data-tabs]');
    if (!scope) return;
    $$('[data-tab]', scope).forEach(function (b) { b.classList.remove('is-active'); });
    $$('[data-tabpane]', scope).forEach(function (p) { p.classList.remove('is-active'); });
    t.classList.add('is-active');
    var pane = $('[data-tabpane="' + t.getAttribute('data-tab') + '"]', scope);
    if (pane) pane.classList.add('is-active');
  });

  /* ---------- sliders (hero) ---------- */
  $$('[data-slider]').forEach(function (root) {
    var slides = $$('.slide', root);
    if (slides.length < 1) return;
    var dots = $$('.slider__dots button', root);
    var i = 0, timer;
    var speed = parseInt(root.getAttribute('data-autoplay') || 0, 10);
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    on($('.slider__arrow--next', root), 'click', function () { go(i + 1); restart(); });
    on($('.slider__arrow--prev', root), 'click', function () { go(i - 1); restart(); });
    dots.forEach(function (d, k) { on(d, 'click', function () { go(k); restart(); }); });
    function restart() { if (!speed) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); }
    if (speed && slides.length > 1) restart();
    // swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { go(dx < 0 ? i + 1 : i - 1); restart(); }
      x0 = null;
    });
    go(0);
  });

  /* ---------- carousels ---------- */
  $$('[data-carousel]').forEach(function (root) {
    var track = $('.carousel__track', root);
    var prev = $('.carousel__nav--prev', root);
    var next = $('.carousel__nav--next', root);
    if (!track) return;
    function step() { return Math.max(track.clientWidth * 0.8, 220); }
    on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    on(next, 'click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    function state() {
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    track.addEventListener('scroll', state, { passive: true });
    window.addEventListener('resize', state);
    state();
  });

  /* ---------- countdown ---------- */
  function tickCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-countdown'), 10) * 1000;
      var diff = end - Date.now();
      if (isNaN(end)) return;
      if (diff <= 0) {
        var reset = parseInt(el.getAttribute('data-recur') || 0, 10);
        if (reset) { end = Date.now() + reset * 1000; el.setAttribute('data-countdown', Math.floor(end / 1000)); diff = reset * 1000; }
        else { diff = 0; }
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;
      var set = function (sel, v) { var n = $(sel, el); if (n) n.textContent = String(v).padStart(2, '0'); };
      set('[data-d]', d); set('[data-h]', h); set('[data-m]', m); set('[data-s]', s);
      var dbox = $('[data-dbox]', el);
      if (dbox && d === 0) dbox.style.display = 'none';
    });
  }
  if ($$('[data-countdown]').length) { tickCountdowns(); setInterval(tickCountdowns, 1000); }

  /* ---------- predictive search ---------- */
  (function predictive() {
    if (!CFG.predictiveSearch) return;
    $$('[data-psearch]').forEach(function (form) {
      var input = $('input[name="q"]', form);
      var box = $('.psearch', form);
      if (!input || !box) return;
      var timer, lastQ = '';
      function close() { box.classList.remove('is-open'); }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () {
          if (q === lastQ) return;
          lastQ = q;
          var url = '/search/suggest?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection,article&resources[limit]=6&section_id=predictive-search';
          fetch(url).then(function (r) { return r.text(); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = doc.querySelector('.psearch-results');
            box.innerHTML = res ? res.innerHTML : '<div class="psearch__empty">No matches</div>';
            box.classList.add('is-open');
          }).catch(close);
        }, 220);
      });
      input.addEventListener('focus', function () { if (box.innerHTML.trim() && input.value.trim().length > 1) box.classList.add('is-open'); });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  })();

  /* ---------- product gallery ---------- */
  (function gallery() {
    var g = $('[data-gallery]');
    if (!g) return;
    var main = $('.gmain__img', g);
    var thumbs = $$('.gthumb', g);
    var idx = 0;
    function show(n) {
      if (!thumbs.length) return;
      idx = (n + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      var src = t.getAttribute('data-full');
      if (main && src) { main.src = src; main.alt = t.getAttribute('data-alt') || ''; }
      thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === idx); });
    }
    thumbs.forEach(function (t, k) {
      on(t, 'click', function (e) { e.preventDefault(); show(k); });
      on(t, 'mouseenter', function () { show(k); });
    });
    on($('.gmain__arrows .prev', g), 'click', function () { show(idx - 1); });
    on($('.gmain__arrows .next', g), 'click', function () { show(idx + 1); });
    // lightbox
    var lb = $('#lightbox');
    if (lb && main) {
      on(main, 'click', function () {
        $('#lightbox-img').src = main.src;
        lb.classList.add('is-open');
        document.body.classList.add('no-scroll');
      });
      on($('.lightbox__nav.next', lb), 'click', function () { show(idx + 1); $('#lightbox-img').src = main.src; });
      on($('.lightbox__nav.prev', lb), 'click', function () { show(idx - 1); $('#lightbox-img').src = main.src; });
    }
    // variant image sync
    document.addEventListener('variant:change', function (e) {
      var v = e.detail;
      if (!v || !v.featured_image) return;
      var target = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == v.featured_image.id; });
      if (target > -1) show(target);
      else if (main) main.src = v.featured_image.src;
    });
  })();

  /* ---------- variant picker ---------- */
  (function variants() {
    var form = $('[data-product-form]');
    if (!form || !window.PRODUCT_VARIANTS) return;
    var variants = window.PRODUCT_VARIANTS;
    var idInput = $('[data-variant-id]', form);
          var scope = form.closest('.pinfo') || document; // option inputs live outside <form>, so scope option lookups here

    function selected() {
      return $$('[data-opt-input]', scope).filter(function (i) { return i.checked || i.tagName === 'SELECT'; })
        .map(function (i) { return i.value; });
    }
    function findVariant() {
      var opts = [];
      $$('[data-opt-group]', scope).forEach(function (g) {
        var checked = $('input:checked', g) || $('select', g);
        opts.push(checked ? checked.value : null);
      });
      return variants.find(function (v) {
        return opts.every(function (o, i) { return !o || v.options[i] === o; });
      });
    }
    function availabilityPass() {
      // grey out combos that don't exist
      $$('[data-opt-group]', scope).forEach(function (g, gi) {
        $$('input[type=radio]', g).forEach(function (input) {
          var test = [];
          $$('[data-opt-group]', scope).forEach(function (g2, i2) {
            if (i2 === gi) { test.push(input.value); }
            else { var c = $('input:checked', g2); test.push(c ? c.value : null); }
          });
          var match = variants.find(function (v) {
            return test.every(function (o, i) { return !o || v.options[i] === o; }) && v.available;
          });
          input.disabled = !match;
        });
      });
    }
    function update() {
      var v = findVariant();
      $$('[data-opt-group]', scope).forEach(function (g) { var c = $('input:checked', g) || $('select', g); var lab = $('[data-opt-selected]', g); if (c && lab) lab.textContent = c.value; });
      var addBtn = $('[data-add-btn]', form);
      var priceNow = $('[data-price-now]');
      var priceWas = $('[data-price-was]');
      var priceOff = $('[data-price-off]');
      var stock = $('[data-stock]');
      var sku = $('[data-sku]');
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = S.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      // url
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (priceWas) {
        if (v.compare_at_price > v.price) {
          priceWas.textContent = formatMoney(v.compare_at_price);
          priceWas.style.display = '';
          if (priceOff) {
            priceOff.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
            priceOff.style.display = '';
          }
        } else {
          priceWas.style.display = 'none';
          if (priceOff) priceOff.style.display = 'none';
        }
      }
      if (sku) sku.textContent = v.sku || '—';
      if (stock) {
        if (!v.available) { stock.className = 'pstock pstock--out'; stock.querySelector('span').textContent = S.sold_out || 'Out of stock'; }
        else { stock.className = 'pstock pstock--in'; stock.querySelector('span').textContent = S.in_stock || 'In stock'; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector('[data-add-label]').textContent = v.available ? (S.add_to_cart || 'Add to cart') : (S.sold_out || 'Sold out');
      }
      $$('[data-sticky-price]').forEach(function (n) { n.textContent = formatMoney(v.price); });
      availabilityPass();
      document.dispatchEvent(new CustomEvent('variant:change', { detail: v }));
    }
    $$('[data-opt-input]', scope).forEach(function (i) { on(i, 'change', update); });
    availabilityPass();

    function collectProps() {
      var props = {};
      $$('[data-line-prop]', form).forEach(function (f) {
        if (f.type === 'checkbox') { if (f.checked) props[f.getAttribute('data-line-prop')] = f.value || 'Yes'; }
        else if (f.value) props[f.getAttribute('data-line-prop')] = f.value;
      });
      return Object.keys(props).length ? props : null;
    }
    function currentQty() {
      return parseInt(($('[name="quantity"]', form) || {}).value || 1, 10);
    }

    on(form, 'submit', function (e) {
      e.preventDefault();
      addToCart(($('[data-variant-id]', form) || {}).value, currentQty(), $('[data-add-btn]', form), collectProps());
    });

    // Buy it now: add the item, then go straight to checkout
    var buyNow = $('[data-buy-now]', form);
    on(buyNow, 'click', function () {
      buyNow.classList.add('btn--loading');
      var payload = { items: [{ id: Number(($('[data-variant-id]', form) || {}).value), quantity: currentQty() }] };
      var props = collectProps();
      if (props) payload.items[0].properties = props;
      fetch(R.cart_add || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            buyNow.classList.remove('btn--loading');
            toast(res.data.description || 'Could not add to cart');
            return;
          }
          window.location.href = '/checkout';
        }).catch(function () {
          buyNow.classList.remove('btn--loading');
          toast('Network error. Please try again.');
        });
    });
  })();

  /* ---------- header category dropdown ---------- */
  $$('[data-psearch]').forEach(function (form) {
    var cat = $('.hsearch__cat', form);
    var input = $('input[name="q"]', form);
    if (!cat || !input) return;
    on(form, 'submit', function (e) {
      // empty search + a chosen category = browse that category
      if (!input.value.trim() && cat.value) {
        e.preventDefault();
        window.location.href = cat.value;
      }
    });
  });

  /* ---------- sticky buy bar ---------- */
  (function stickyBuy() {
    var bar = $('.stickybuy');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(anchor);
  })();

  /* ---------- collection: filters + sort ---------- */
  (function collection() {
    var results = $('#CollectionResults');
    if (!results) return;

    function forms() { return $$('[data-filter-form]'); }

    function render(url, push) {
      results.style.opacity = '.45';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRes = doc.querySelector('#CollectionResults');
        var newFilters = doc.querySelector('[data-filter-form]');
        if (newRes) results.innerHTML = newRes.innerHTML;
        if (newFilters) {
          forms().forEach(function (f) {
            var open = $$('.fgroup.is-open', f).map(function (g) { return g.getAttribute('data-group'); });
            f.innerHTML = newFilters.innerHTML;
            open.forEach(function (id) {
              var g = $('.fgroup[data-group="' + id + '"]', f);
              if (g) g.classList.add('is-open');
            });
          });
        }
        results.style.opacity = '';
        paintWish();
        if (push) history.pushState({}, '', url);
        window.scrollTo({ top: results.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      }).catch(function () { results.style.opacity = ''; });
    }

    function submitFilters(e) {
      var form = e.target.closest('[data-filter-form]');
      if (!form) return;
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v) params.append(k, v); });
      var sort = $('[data-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      render(location.pathname + '?' + params.toString(), true);
    }
    document.addEventListener('change', submitFilters);
    document.addEventListener('submit', submitFilters);
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-sort]')) {
        var params = new URLSearchParams(location.search);
        params.set('sort_by', e.target.value);
        render(location.pathname + '?' + params.toString(), true);
      }
    });
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-filter-link]');
      if (link) { e.preventDefault(); render(link.href, true); }
      var pag = e.target.closest('.pager a');
      if (pag) { e.preventDefault(); render(pag.href, true); }
    });
    window.addEventListener('popstate', function () { render(location.href, false); });

    // view toggle
    $$('[data-view]').forEach(function (b) {
      on(b, 'click', function () {
        var v = b.getAttribute('data-view');
        $$('[data-view]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var grid = $('.pgrid', results || document);
        if (grid) grid.classList.toggle('pgrid--list', v === 'list');
        try { localStorage.setItem('gm_view', v); } catch (err) { }
      });
    });
    try {
      var saved = localStorage.getItem('gm_view');
      if (saved === 'list') { var b = $('[data-view="list"]'); if (b) b.click(); }
    } catch (err) { }
  })();

  /* ---------- wishlist (local) ---------- */
  function wish() {
    try { return JSON.parse(localStorage.getItem('gm_wish') || '[]'); } catch (e) { return []; }
  }
  function saveWish(list) { try { localStorage.setItem('gm_wish', JSON.stringify(list)); } catch (e) { } }
  function paintWish() {
    var list = wish();
    $$('[data-wish]').forEach(function (b) { b.classList.toggle('is-on', list.indexOf(b.getAttribute('data-wish')) > -1); });
    $$('.js-wish-count').forEach(function (n) { n.textContent = list.length; n.style.display = list.length ? '' : 'none'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wish');
    var list = wish();
    var i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); toast(S.wish_removed || 'Removed from wishlist'); }
    else { list.push(id); toast(S.wish_added || 'Saved to wishlist'); }
    saveWish(list);
    paintWish();
  });
  paintWish();

  /* ---------- recently viewed ---------- */
  (function recent() {
    var handle = CFG.productHandle;
    if (handle) {
      try {
        var list = JSON.parse(localStorage.getItem('gm_recent') || '[]');
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem('gm_recent', JSON.stringify(list.slice(0, 12)));
      } catch (e) { }
    }
    var holder = $('[data-recent]');
    if (!holder) return;
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('gm_recent') || '[]'); } catch (e) { }
    handles = handles.filter(function (h) { return h !== handle; }).slice(0, 10);
    if (!handles.length) { holder.closest('section') && (holder.closest('section').style.display = 'none'); return; }
    var track = $('.carousel__track', holder);
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '?section_id=product-card-ajax')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (chunks) {
      var html = chunks.map(function (c) {
        if (!c) return '';
        var doc = new DOMParser().parseFromString(c, 'text/html');
        var card = doc.querySelector('.pcard');
        return card ? card.outerHTML : '';
      }).join('');
      if (html && track) { track.innerHTML = html; paintWish(); }
      else if (holder.closest('section')) holder.closest('section').style.display = 'none';
    });
  })();

  /* ---------- quick view ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quickview]');
    if (!b) return;
    e.preventDefault();
    var handle = b.getAttribute('data-quickview');
    var qv = $('#quickview');
    if (!qv) return;
    $('#quickview-body').innerHTML = '<div class="qv__grid"><div class="skeleton" style="aspect-ratio:1/1"></div><div><div class="skeleton" style="height:26px;margin-bottom:12px"></div><div class="skeleton" style="height:18px;width:60%;margin-bottom:20px"></div><div class="skeleton" style="height:46px"></div></div></div>';
    openPanel('quickview');
    fetch('/products/' + handle + '?section_id=quick-view')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.qv-inner');
        $('#quickview-body').innerHTML = inner ? inner.innerHTML : '<p>Could not load product.</p>';
      });
  });

  /* ---------- scroll reveal ---------- */
  if (CFG.animations && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- newsletter inline feedback ---------- */
  $$('form[action*="/contact"]').forEach(function (f) {
    on(f, 'submit', function () {
      var b = f.querySelector('button[type=submit]');
      if (b) b.classList.add('btn--loading');
    });
  });

  /* ---------- init cart paint ---------- */
  paintShipBar(CFG.cartTotal || 0);
})();
